import React from "react";
import {IconButton, TableBody, TablePagination,
} from "@material-ui/core";


// constants

// styling
import PropTypes from "prop-types";
import withShipment from "../../../withShipment";
import CustomToolbar from "../../global/CustomToolbar";
import {
    CUSTOMERS_TOOLBAR_TITLE,
    DEFAULT_ROWS_PER_PAGE,
    DEFAULT_SORT_BY_HEAD_CELL,
    ROWS_PER_PAGE_LABEL, CREATE_CUSTOMER_TITLE, BACK_TO_MENU, MANAGE_CUSTOMERS_HEAD_CELLS
} from "./constants";
import ManageCustomerStepper from "./ManageCustomerStepper";
import Paper from "@material-ui/core/Paper";
import {
    availableLocationsSelector,
    emailTemplatesSelector,
    packagesSelector,
    productsSelector,
} from "../../../redux/selectors/settings";
import {
    listProducts,
    listPackages,
    getEmailTemplates,
    listAvailableLocations,
} from "../../../redux/actions/settings";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import GlobalTableHead from "../../global/Table/GlobalTableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import EditIcon from "@material-ui/icons/Edit";
import { ASC, DESC } from "../../global/constants";
import SearchableTable from "../../global/Search/SearchableTable";
import CustomTableHeader from "../../global/Table/CustomTableHeader";
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import {createCustomer, listCustomers, processCustomerInvoices, updateCustomer} from "../../../redux/actions/customer";
import {customersSelector} from "../../../redux/selectors/customer";


class ManageCustomerTable extends SearchableTable {

    constructor(props) {
        super(props);
        this.state = {
            addingCustomer: false,
            editingCustomer: null,
            order: ASC,
            page: 0,
            rowsPerPage: DEFAULT_ROWS_PER_PAGE,
            orderBy: DEFAULT_SORT_BY_HEAD_CELL,
            isSearch: false, // true if search value is not empty, false otherwise
            searchValue: "", // the value in the search field (updates on change)
            searchRows: 0, // number of rows displayed while search criteria is met
            missingError: false, //missing error 
            availableLocations:[]
        }
    }
    onSearchValueChange = (e) => {
        this.setState({
            isSearch: e.target.value.length > 0,
            searchValue: e.target.value,
            page: 0
        });
    }

    componentDidMount() {
        this.props.listAvailableLocations()
        this.props.listCustomers()
        this.props.listProducts()
        this.props.listPackages()
        this.props.getEmailTemplates()
    }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        if (this.props.availableLocations && this.props.availableLocations !== prevProps.availableLocations) {
            const updatedLocations = this.props.availableLocations.map((locationInfo)=>{
                let location = {
                    name: locationInfo.name,
                    shipAddressId: locationInfo.shipAddressId
                }
                return location
            })
            this.setState({
                availableLocations: updatedLocations
            })
        }
    }

    getDisplayed = (rows) => {
        if (!rows)
            return [];
        return [...rows.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)];
    }

    handleClose = () => {
        this.setState({
            addingCustomer: false
        }, () => this.setState({ editingCustomer: null }))
    }

    handleOpenCustomer = (customer) => {
        this.setState({
            editingCustomer: customer
        })
    }

    handleRequestSort = (event, property) => {
        const isAsc = this.state.orderBy === property && this.state.order === ASC;
        this.setState({
            order: isAsc ? DESC : ASC,
            orderBy: property,
        });
    };


    handleSave = (addingCustomer, data) => {
        if (data.name === '' || data.phone === '' || data.addressLine1 === '' || data.city === '' || data.state === '' ||
            data.postalCode === '' || data.country === '' || data.email === '' || data.customerShortcode === '' ||
            data.currencyCode === '') {
            return
        } else {
            if (addingCustomer) {

                this.props.createCustomer(data, () => window.location.reload())
            } else {

                this.props.updateCustomer(data)

                this.setState({
                    addingCustomer: false,
                }, () => {
                    this.setState({
                        editingCustomer: null
                    })
                }
                )
            }
        }
    }

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: event.target.value,
            page: 0,
        });
    };

    handleChangePage = (event, newPage) => {
        this.setState({
            page: newPage,
        });
    };

    handleExecute = (data) => {
        this.props.processCustomerInvoices(data)
    }

    render() {
        return (
            <>

                <Paper className='paper'>
                    <ErrorFeedbackBar />
                    {!this.state.editingCustomer ?

                        this.state.addingCustomer ?
                            <ManageCustomerStepper
                                addingCustomer={true}
                                handleClose={this.handleClose}
                                products={this.props.products}
                                packages={this.props.packages}
                                handleSave={this.handleSave}
                                emailTemplates={this.props.emailTemplates}
                                handleExecute={this.handleExecute}
                                creatingOrder={this.state.addingCustomer || (!!this.state.editingCustomer)}
                                title={CUSTOMERS_TOOLBAR_TITLE}
                                createTitle={CUSTOMERS_TOOLBAR_TITLE}
                                backTitle={CUSTOMERS_TOOLBAR_TITLE}
                                onClick={() => { this.setState({ addingCustomer: true }) }}
                                locations={this.state.availableLocations}
                            />
                            :
                            <>
                                <CustomToolbar
                                    creatingOrder={this.state.addingCustomer || (!!this.state.editingCustomer)}
                                    title={CUSTOMERS_TOOLBAR_TITLE}
                                    createTitle={CREATE_CUSTOMER_TITLE}
                                    backTitle={BACK_TO_MENU}
                                    handleClose={this.handleClose}
                                    onClick={() => { this.setState({ addingCustomer: true }) }}
                                />
                                <CustomTableHeader
                                    searchText={this.state.searchValue}
                                    onSearchValueChange={this.onSearchValueChange}
                                    pagination={
                                        <TablePagination
                                            className="table-pagination"
                                            labelRowsPerPage={ROWS_PER_PAGE_LABEL}
                                            rowsPerPageOptions={[5, 25, 50, 100, {value: this.props.customers ? this.props.customers.length : 0, label: "All"} ]}
                                            count={!this.props.customers ? 0 : this.filterBySearch(this.props.customers).length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    }
                                />

                                <TableContainer>
                                    <Table size='medium'>
                                        <GlobalTableHead
                                            isCreatePurchaseOrderTable={false}
                                            isShipmentTable={false}
                                            headCells={MANAGE_CUSTOMERS_HEAD_CELLS}
                                            order={this.state.order}
                                            orderBy={this.state.orderBy}
                                            onRequestSort={this.handleRequestSort}
                                            rowCount={!this.props.customers ? 0 : this.props.customers.length}
                                        />
                                        <TableBody>
                                            {this.getDisplayed(this.stableSort(this.filterBySearch(this.props.customers), this.getComparator(this.state.order, this.state.orderBy))).map((row, index) => {

                                                return (
                                                    <TableRow hover onDoubleClick={() => this.handleOpenCustomer(row)}>
                                                        <TableCell>
                                                            <IconButton onClick={() => this.handleOpenCustomer(row)}>
                                                                <EditIcon />
                                                            </IconButton>
                                                        </TableCell>
                                                        <TableCell className='cellPadding'>
                                                            {row.name}
                                                        </TableCell>
                                                        <TableCell className='cellPadding'>
                                                            {row.addressLine1}
                                                        </TableCell>
                                                        <TableCell className='cellPadding'>
                                                            {row.phone}
                                                        </TableCell>


                                                    </TableRow>
                                                );

                                            })
                                            }
                                        </TableBody>

                                    </Table>


                                </TableContainer>
                            </>


                        :
                        <ManageCustomerStepper
                            addingCustomer={false}
                            editingCustomer={this.state.editingCustomer}
                            creatingOrder={this.state.addingCustomer || (!!this.state.editingCustomer)}
                            handleClose={this.handleClose}
                            products={this.props.products}
                            packages={this.props.packages}
                            handleSave={this.handleSave}
                            emailTemplates={this.props.emailTemplates}
                            handleExecute={this.handleExecute}
                            title={CUSTOMERS_TOOLBAR_TITLE}
                            createTitle={CUSTOMERS_TOOLBAR_TITLE}
                            backTitle={CUSTOMERS_TOOLBAR_TITLE}
                            onClick={() => { this.setState({ addingCustomer: true }) }}
                            locations={this.state.availableLocations}
                        />
                    }
                </Paper>

            </>

        );
    }


}


const mapStateToProps = (state) => ({
    products: productsSelector(state),
    customers: customersSelector(state),
    packages: packagesSelector(state),
    emailTemplates: emailTemplatesSelector(state),
    availableLocations: availableLocationsSelector(state),
})

const actionCreators = {
    listProducts,
    listCustomers,
    createCustomer,
    updateCustomer,
    listPackages,
    getEmailTemplates,
    processCustomerInvoices,
    listAvailableLocations,
}

ManageCustomerTable.propTypes = {
    availableLocations: PropTypes.array
}

ManageCustomerTable.defaultProps = {
    availableLocations: [],
}

export default withShipment({
    mapStateToProps,
    actionCreators
}, ManageCustomerTable);